import { adminRoutes } from "./_adminRoutes";
import { borrowerRoutes } from "./_borrowerRoutes";
import { lenderRoutes } from "./_lenderRoutes";

export default {
  adminRoutes,
  borrowerRoutes,
  lenderRoutes,
};
